<template>
  <div :class="$style.headerContainer">
    <h3 :class="$style.title">
      {{ title }}
    </h3>
    <p>
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'MdmHeaderTitle',

  props: {
    description: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style module>
@value (jcGrey600) from '~css/brand-colors.css';

.headerContainer {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}

.headerContainer .title {
  color: jcGrey600;
}
</style>
